import ReactDOM from 'react-dom/client'
import { PortalProviders } from '@portals/shared/PortalProviders'
import { DeliveryPortal } from '@portals/delivery/DeliveryPortal'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <PortalProviders portal="delivery">
    <DeliveryPortal />
  </PortalProviders>
)
